module.exports = __webpack_public_path__ + "img/ContratoSVExtranjera3.77c445bf.jpg";